import { ENTITY_TYPES_DROPDOWN_CONFIG } from "@shared/utils/constants";

export const MODAL_DATA = Object.freeze({
    dueDate: "",
    time: "",
    note: "",
    task_assignee_id: "",
    task_assignee_type: "",
    tenantUsers: {
        model: [],
        options: [],
    },
    clientUsers: {
        model: [],
        options: [],
    },
    files: [],
    riskMitigation: {
        mode: false,
        rawData: [],
        category: {
            model: null,
            options: [],
        },
        subCategory: {
            model: null,
            options: [],
        },
        title: {
            model: "",
            options: [],
        }
    }
});

export const MULTI_SELECT_CONFIG = Object.freeze({
    class: "flex-1",
    type: "multi-select",
    variant: "alt",
    searchable: true,
    config: {
        ...ENTITY_TYPES_DROPDOWN_CONFIG,
        limit: 4,
    },
});

export const SINGLE_SELECT_CONFIG = Object.freeze({
    searchable: true,
    colors: {
        text: '#282828',
        bg: 'white',
        svg: '#282828',
        border: '#bcbcbc',
    },
    config: { label: 'label', trackBy: 'value' },
    maxWidth: '100%',
    minWidth: '100%',
});

export const FILE_COUNT_LIMIT = 10;

export const FILE_SIZE_LIMIT = 5; // in MB
